import { render, staticRenderFns } from "./FailedDeliveryPerformMails.vue?vue&type=template&id=0de9a0e8&scoped=true"
import script from "./FailedDeliveryPerformMails.vue?vue&type=script&lang=js"
export * from "./FailedDeliveryPerformMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de9a0e8",
  null
  
)

export default component.exports